(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rf-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rf-collections')) {
    customElements.define('rf-collections', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.rf-col__list');
        this.track = this.querySelector('.rf-col__progress');
        this.bar = this.track ? this.track.querySelector('i') : null;

        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.hasAttribute('data-autoplay') && !still && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.classList.toggle('is-live', entries[0].isIntersecting);
          }, { threshold: 0.15 });
          this.io.observe(this);
        }

        this.video = this.querySelector('.rf-col__video');
        if (this.video && this.video.dataset.src) {
          if (still || !('IntersectionObserver' in window)) {
            this.video.src = this.video.dataset.src;
            this.video.controls = true;
          } else {
            this.vio = new IntersectionObserver((entries) => {
              const v = this.video;
              if (entries[0].isIntersecting) {
                if (!v.getAttribute('src')) v.src = v.dataset.src;
                const p = v.play(); if (p && p.catch) p.catch(() => {});
              } else if (!v.paused) {
                v.pause();
              }
            }, { threshold: 0.45 });
            this.vio.observe(this.video);
          }
        }

        this.prev = this.querySelector('.rf-col__nav--prev');
        this.next = this.querySelector('.rf-col__nav--next');
        if (this.list && this.prev && this.next) {
          const go = (dir) => {
            const item = this.list.querySelector('.rf-col__item');
            const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
            const step = item ? item.getBoundingClientRect().width + gap : this.list.clientWidth;
            const per = Math.max(1, Math.round((this.list.clientWidth + gap) / step));
            this.list.scrollBy({ left: dir * step * per, behavior: 'smooth' });
          };
          this.prev.addEventListener('click', () => go(-1));
          this.next.addEventListener('click', () => go(1));
        }

        this.more = this.querySelector('.rf-col__more');
        if (this.more && this.list) {
          const total = this.list.querySelectorAll('.rf-col__item').length;
          const visible = parseInt(this.dataset.visible, 10) || 8;
          const wrap = this.more.parentElement;
          if (total > visible) {
            const text = this.more.querySelector('span');
            const closed = (this.more.dataset.label || '').replace('[count]', total);
            const opened = this.more.dataset.less || closed;
            text.textContent = closed;
            wrap.hidden = false;
            this.more.addEventListener('click', () => {
              const open = this.classList.toggle('is-open');
              this.more.setAttribute('aria-expanded', open ? 'true' : 'false');
              text.textContent = open ? opened : closed;
              if (!open) {
                // back to the first cards, and bring the section up if the visitor was further down
                this.list.scrollLeft = 0;
                const top = this.getBoundingClientRect().top;
                if (top < 0) window.scrollTo({ top: window.scrollY + top - 90, behavior: 'smooth' });
              }
              if (this.update) this.update();
            });
          }
        }

        if (this.list && this.bar) {
          this.update = () => {
            const max = this.list.scrollWidth - this.list.clientWidth;
            this.track.hidden = max <= 4;
            if (this.prev && this.next) {
              this.prev.hidden = this.next.hidden = max <= 4;
              this.prev.disabled = Math.abs(this.list.scrollLeft) <= 2;
              this.next.disabled = Math.abs(this.list.scrollLeft) >= max - 2;
            }
            if (max <= 4) return;
            const shown = this.list.clientWidth / this.list.scrollWidth;
            const done = Math.min(1, Math.abs(this.list.scrollLeft) / max);
            this.bar.style.width = (shown * 100) + '%';
            this.bar.style.transform = 'translateX(' + (done * (1 / shown - 1) * 100) + '%)';
          };
          this.list.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.vio) this.vio.disconnect();
        if (this.update) window.removeEventListener('resize', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
